'use client';

import { useEffect } from 'react';

import { SKIP_WAITING_SCREEN_COOKIE } from '../lib/waitingScreen';

const SECRET = 'letmein';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days

/**
 * Hidden escape hatch while the holding page is up: typing `letmein` anywhere
 * on the page sets the skip cookie and reloads, so the server layout serves the
 * full app on the next request. The cookie is intentionally not httpOnly so the
 * client can write it; this is an obscurity gate, not a security boundary.
 */
export default function WaitingScreenSkip() {
  useEffect(() => {
    let buffer = '';

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key.length !== 1) return;

      buffer = (buffer + event.key.toLowerCase()).slice(-SECRET.length);
      if (buffer !== SECRET) return;

      const secure = window.location.protocol === 'https:' ? '; secure' : '';
      document.cookie = `${SKIP_WAITING_SCREEN_COOKIE}=1; path=/; max-age=${COOKIE_MAX_AGE}; samesite=lax${secure}`;
      window.location.reload();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, []);

  return null;
}
